import ProposalCustomerHero from "@/components/proposal/ProposalCustomerHero";
import { ProposalPremiumDisplayContext } from "@/components/proposal/ProposalPremiumDisplayContext";
import { PROPOSAL_COPY_FONT } from "@/lib/proposalTheme";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export type ProposalPremiumCoverInput = {
  customerName: string;
  proposalTitle?: string | null;
  proposalRef: string;
};

type Props = {
  cover: ProposalPremiumCoverInput;
  /** When false, cover uses compact layout (legacy). Premium proposals default true. */
  fullViewportCover?: boolean;
  contentLead?: ReactNode;
  children: ReactNode;
};

/**
 * Canonical premium proposal shell — full-viewport cover, content wrapper, display context.
 * Used by projector (D-Tools) and retail premium proposals.
 */
export default function ProposalPremiumShell({
  cover,
  fullViewportCover = true,
  contentLead,
  children,
}: Props) {
  return (
    <ProposalPremiumDisplayContext.Provider value={{ fullViewportCover }}>
      <div className="w-full" style={{ fontFamily: PROPOSAL_COPY_FONT }}>
        <ProposalCustomerHero
          customerName={cover.customerName}
          proposalTitle={cover.proposalTitle}
          proposalRef={cover.proposalRef}
          fullViewport={fullViewportCover}
          showLogo={false}
        />

        <div
          className={cn(
            fullViewportCover ? "mx-auto max-w-5xl space-y-10 px-6 pb-10" : "space-y-10",
          )}
          data-testid={fullViewportCover ? "proposal-content-below-cover" : undefined}
        >
          {contentLead}
          {children}
        </div>
      </div>
    </ProposalPremiumDisplayContext.Provider>
  );
}
